module.exports = __webpack_public_path__ + "static/media/settings_darkmode_blue.6a7aeb90.svg";